import { createApp } from "vue";
import * as VueRuntime from "vue";
import { compile } from "@vue/compiler-dom";

import { applyCommonGlobals } from "../layout/createLayoutApp";
import { applyStaticI18nGlobals, createStaticI18n } from "./i18n";
import { getStaticPageOptions } from "./StaticPage";
import { PerfectScrollbarPlugin } from "vue3-perfect-scrollbar";

function buildRootComponent(model, isMobile) {
  const template = `<div class="static-page-content cms-typography-content">${model.template}</div>`;
  const { code } = compile(template, { mode: "function" });
  const render = new Function("Vue", `${code}; return render`)(VueRuntime);
  const baseOptions = getStaticPageOptions(model);

  return {
    ...baseOptions,
    render,
  };
}

export function createStaticPageApp(model: any, options: {ssr: boolean, isMobile?: boolean, resources?: any}) {
  const { ssr, isMobile = false, resources = null } = options;
  const app = createApp(buildRootComponent(model, isMobile));

  applyCommonGlobals(app, { ssr, resources, isMobile });
  const i18n = createStaticI18n(resources ?? (typeof window !== "undefined" ? window.Resources : {}));
  app.use(i18n);
  applyStaticI18nGlobals(app, i18n);
  app.use(PerfectScrollbarPlugin);

  return app;
}
